import {SET_COMPANY_NAME} from '../constants/actionTypes';
import initialState from './initialState';
import _ from "lodash";

export default function companyNameReducer(state = initialState.companyName, action) {
  switch (action.type) {
    case SET_COMPANY_NAME:
      return _.get(action, 'companyName', null);
    default:
      return state;
  }
}

